import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router} from 'react-router-dom';
import AuthProvider from './providers/AuthProvider';

import './assets/css/docs.css';
import './assets/css/fonts-googleapis.css';
import './assets/vendor/fontawesome-free/css/all.min.css'

import App from './App';
import * as serviceWorker from './serviceWorker';

// Router Component must be at the index.js level so
// useHistory() hook can be used
// see https://flaviocopes.com/react-router-uselocation-usehistory-undefined/
const Root = () => (
        <AuthProvider>
            <Router>
                <App />
            </Router>
        </AuthProvider>
);

ReactDOM.render(
    <Root />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
